import { useQuery } from "@tanstack/react-query";
import {
  settingsService,
  type SettingsProfile,
} from "@/services/SettingsService";

export const SETTINGS_STALE_TIME = 1000 * 60 * 5;

export const SETTINGS_PROFILE_QUERY_KEY = ["settings", "profile"] as const;

export const fetchSettingsProfile = (): Promise<SettingsProfile> =>
  settingsService.getProfile();

export const useSettingsProfile = () =>
  useQuery({
    queryKey: SETTINGS_PROFILE_QUERY_KEY,
    queryFn: fetchSettingsProfile,
    staleTime: SETTINGS_STALE_TIME,
  });
